import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Container, Box} from '@material-ui/core';
import OrdersProvider from './context/OrdersContext';
import OrdersSummary from './components/OrdersSummary';
import OrdersFilters from './components/OrdersFilters';
import OrdersTable from './components/OrdersTable';
import BulkActionsBar from './components/BulkActionsBar';
import ExportDialog from './components/ExportDialog';
import DriverAssignDialog from './components/DriverAssignDialog';
import WalletDialog from './components/WalletDialog';
import OrderHistoryDialog from './components/OrderHistoryDialog';
import UpdateSlotDialog from './components/UpdateSlotDialog';
import DeliveredAtDialog from './components/DeliveredAtDialog';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: '#f5f7fa',
		minHeight: '100vh',
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	container: {
		maxWidth: '100%',
		padding: theme.spacing(0, 3),
	},
	section: {
		marginBottom: theme.spacing(3),
	},
}));

/**
 * Modern Admin Orders Page V2
 *
 * Features:
 * - Financial dashboard with real-time statistics
 * - Advanced filtering and search
 * - Bulk operations support
 * - Modern Material-UI v4 design
 * - Clean code with custom hooks
 * - Responsive and accessible
 */
const OrdersV2 = () => {
	const classes = useStyles();

	return (
		<OrdersProvider>
			<Box className={classes.root}>
				<Container className={classes.container}>
					{/* Financial Summary Cards */}
					<Box className={classes.section}>
						<OrdersSummary/>
					</Box>

					{/* Filters and Search */}
					<Box className={classes.section}>
						<OrdersFilters/>
					</Box>

					{/* Bulk Actions Bar (appears when items selected) */}
					<BulkActionsBar/>

					{/* Orders Data Table */}
					<Box className={classes.section}>
						<OrdersTable/>
					</Box>

					{/* Dialogs */}
					<ExportDialog/>
					<DriverAssignDialog/>
					<WalletDialog/>
					<OrderHistoryDialog/>
					<UpdateSlotDialog/>
					<DeliveredAtDialog/>
				</Container>
			</Box>
		</OrdersProvider>
	);
};

export default OrdersV2;
